import React, { useState } from 'react';
import AttenteRequete from '../../../../hoc/AttenteRequete/AttenteRequete';
import Bouton from '../../../UI/Bouton/Bouton';
import { checkMot } from '../../../../ressources/functionJS/checkMot';
import * as requestType from '../../../../ressources/glossaires/glossaire_requetes';
import * as glossaire_affichage_type_capteur from '../../../../ressources/glossaires/glossaire_affichage_type_capteur';
import * as s from '../../../../ressources/StyleGlobal/StyleGlobal';
import styles from './AjouterSensorType.module.scss';

const AjouterSensorType = ({ reqAjouter, annuler }) => {
  // Separate state hooks for each field
  const [sensorTypeName, setSensorTypeName] = useState('');
  const [sensorTypeDisplay, setSensorTypeDisplay] = useState(
    glossaire_affichage_type_capteur.default_display
  );

  // Event handlers
  const handleSensorTypeNameChange = (event) => {
    setSensorTypeName(event.target.value);
  };

  const handleDisplayTypeChange = (event) => {
    setSensorTypeDisplay(event.target.value);
  };

  return (
    <div className={styles.ConteneurInfo}>
      <div
        className={[s.container, s.border, s.text_left, styles.Formulaire].join(
          ' '
        )}
      >
        <div className={s.form_group}>
          <div className={[s.form_row, s.align_items_center].join(' ')}>
            <div className={s.col_12}>
              <label className={s.col_form_label}>
                {checkMot('sensor_type_display')}
              </label>
              <input
                type="text"
                pattern="[0-9a-zA-Z._%+-\\s ]+"
                className={[s.form_control, s.mb_2].join(' ')}
                placeholder="sensor_type_name"
                value={sensorTypeName}
                onChange={handleSensorTypeNameChange}
              />
            </div>
          </div>
        </div>

        <div className={s.form_group}>
          <div className={[s.form_row, s.align_items_center].join(' ')}>
            <div className={s.col_12}>
              <label className={s.col_form_label}>
                {checkMot('sensor_type_display')}
              </label>
              <select
                onChange={handleDisplayTypeChange}
                value={sensorTypeDisplay}
                className={s.custom_select}
              >
                {Object.entries(glossaire_affichage_type_capteur).map(
                  ([key, value]) => (
                    <option key={key} value={value}>
                      {checkMot(value)}
                    </option>
                  )
                )}
              </select>
            </div>
          </div>
        </div>

        <div className={s.form_group}>
          <div className={[s.d_flex, s.justify_content_between].join(' ')}>
            <div>
              <Bouton cliquer={annuler}>{checkMot('annuler')}</Bouton>
            </div>
            <div>
              <AttenteRequete
                request_type={requestType.creation_d_un_sensor_type}
                str={checkMot('creation_en_cour')}
              >
                <Bouton
                  cliquer={() => reqAjouter(sensorTypeName, sensorTypeDisplay)}
                >
                  {checkMot('creer')}
                </Bouton>
              </AttenteRequete>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AjouterSensorType;
